import { useAppShellPush } from '@ids/appshell';
import { useAppContext } from '@ids/context/App';
import { trimTrailingSlash } from '@ids/router/helpers';

const useIDSPush = () => {
    const push = useAppShellPush();
    const { idsPath } = useAppContext();
    return (path: string) => push(`${trimTrailingSlash(idsPath)}${trimTrailingSlash(path)}/`);
};

export default useIDSPush;
